import { c as _c } from "react/compiler-runtime";
import { Card } from '@svs/ui/react/card';
import { Skeleton } from '@svs/ui/react/skeleton';
import type { ReactNode } from 'react';

/**
 * Loading state for the SideNav component.
 *
 * @returns loading state for the SideNav component
 */
export default function SideNavLoading() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex gap-2"><Skeleton className="h-5 w-17.5" /><Skeleton className="h-5 w-17.5" /><Skeleton className="h-5 w-17.5" /><Skeleton className="h-5 w-17.5" /><Skeleton className="h-5 w-17.5" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-4 flex justify-center gap-2"><Skeleton className="h-5 w-17.5" /><Skeleton className="h-5 w-17.5" /><Skeleton className="h-5 w-17.5" /><Skeleton className="h-5 w-17.5" /><Skeleton className="h-5 w-17.5" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="mb-6 h-5 w-50" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="grid grid-cols-[1fr_auto_auto_auto] gap-4"><div /><Skeleton className="h-4 w-4" /><Skeleton className="h-4 w-4" /><Skeleton className="h-4 w-4" /></div>;
    t4 = Array.from({
      length: 3
    }).map(_temp);
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-4 grid grid-cols-[1fr_auto_auto] gap-4"><Skeleton className="h-4 w-32" /><Skeleton className="h-4 w-10" /><Skeleton className="h-4 w-10" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mb-3">{t2}{t3}{t4}{t5}<div className="border-stroke-low grid grid-cols-[1fr_auto_auto] gap-4 border-t py-3"><Skeleton className="h-4 w-38" /><Skeleton className="h-4 w-8" /><Skeleton className="h-4 w-8" /></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Card className="bg-surface-elevated col-span-5 hidden h-fit w-full rounded-md p-4 lg:block">{t0}{t1}<div className="mt-5">{t6}<div className="mb-3"><Skeleton className="mb-6 h-5 w-40" />{["80px", "60px", "70px", "90px"].map(_temp2)}</div></div></Card>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}
function _temp2(width, i_0) {
  return <div key={i_0} className="border-stroke-low flex justify-between border-t py-3"><Skeleton className="h-4 w-15" /><Skeleton className="h-4" style={{
      width
    }} /></div>;
}
function _temp(_, i) {
  return <div key={i} className="border-stroke-low grid grid-cols-[1fr_auto_auto_auto] gap-4 border-t py-3"><Skeleton className="h-4 w-30" /><Skeleton className="h-4 w-8" /><Skeleton className="h-4 w-8" /><Skeleton className="h-4 w-8" /></div>;
}